import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.5 }}
      style={{ padding: '2rem', textAlign: 'center' }}
    >
      <h1>Hi, I'm Cornelius 👋</h1>
      <p>Welcome to my portfolio site.</p>
    </motion.section>
  );
};

export default Hero;

